export default [
  { name: 'phone', color: '#4F5C7C' },
  { name: 'tablet', color: '#65759A' },
  { name: 'desktop', color: '#7182AA' },
];
